<div #menu class="context-menu">
  <div
    [ngClass]="{ disabled: !option.isAvailable }"
    *ngFor="let option of options"
    (click)="optionActionWrapper(option)"
    >{{ option.label }}</div
  >
</div>
